import { render, staticRenderFns } from "./ApplicationsImport.vue?vue&type=template&id=15c03d0c&"
import script from "./ApplicationsImport.vue?vue&type=script&lang=js&"
export * from "./ApplicationsImport.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsImport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports